import axios from 'axios'

const state = {
    setStories: null,
    promotionPlans: null,
}

const getters = {
    setStories (state) {
        return state.setStories
    },
    promotionPlans (state) {
        return state.promotionPlans
    },
    // console.log(Object.assign({}, activeUser))
}

const actions = {
    async fetchStories({ commit }, itemsObj) {
        let country = itemsObj.country ? itemsObj.country : 'world'
        let category = itemsObj.category ? itemsObj.category : 'general'
        if(category === 'donations') category = 'general'

        let response = await axios.get(`/stories/allstories/${category}/${country}`)
        if(!response.data.error){
            commit('SET_STORIES', response.data.result)
        }
        if(response.data){ return response.data }
    },

    async fetchPromotionPlans({ commit, getters }) {
        let response = await axios.get(`/promotions/plans/${getters.user.alphaCode}`)
        if(!response.data.error){
            commit('SET_PLANS', response.data.result)
        }
        return response.data
    },

    async promoteItem({ _ }, promotionObj) {
        let response = await axios.post('/promotions/promote', promotionObj)
        if(response.data){
            // attempt launching the payment gateway url
            try {
                if(response.data.link !== null){
                    // redirect user to payment url to obtain transactionId for completePromoteItem
                    window.location = response.data.link
                }
            } catch (error) {}
        }
        return response.data
    },
    
    async completePromoteItem({ dispatch }, promotionObj) {
        /**
         * promotionObj was re-built from the content of localStorage.removeItem('_m12sp60u')
         * now remove it from localStorage to prevent page loop when the axios result returns
         */
        localStorage.removeItem('_m12sp60u')
        let response = await axios.post('/promotions/promote', promotionObj)
        if(!response.data.error){
            dispatch('modifyItemObj', response.data.result)
        }
        return response.data
    },
    
    async demoteItem({ dispatch }, demotionObj) {
        let response = await axios.post('/promotions/demote', demotionObj)
        if(!response.data.error){
            dispatch('modifyItemObj', response.data.result)
        }
        return response.data
    },
}

const mutations = {
    SET_STORIES: (state, setStories) => (state.setStories = setStories),
    SET_PLANS: (state, promotionPlans) => (state.promotionPlans = promotionPlans),
}

export default {
    state,
    getters,
    actions,
    mutations
}